import React, {useState} from "react";
import { Box, Button, Checkbox, Column, Columns, Field, Title } from "@allxsmith/bestax-bulma";
import useInput from "../../../hooks/useInput";
import {useDispatch} from "react-redux";
import usePostWorkType from "../../../hooks/usePostWorkType";


export default function NewWorkType(props){
    const dispatch = useDispatch();
    let [name, nameInput, setName] = useInput({
        type: "text",
        label: "Name",
    });
    let [freeOfCharge, setFreeOfCharge] = useState(false);
    let [approval, setApproval] = useState(false);
    let [warrantyClaim, setWarrantyClaim] = useState(false);
    const [, postWorkType] = usePostWorkType({
        name: name,
        free_of_charge: freeOfCharge,
        approval_needed: approval,
        warranty_claim: warrantyClaim
    })
    const onClear = () => {
        setName("");
        setFreeOfCharge(false);
        setApproval(false);
    }


    const onFreeOfChargeCheck = e => {
        setFreeOfCharge(!freeOfCharge);
    };

    const onApprovalCheck = e => {
        setApproval(!approval);
    }

    const onWarrantyClaimCheck = e => {
        setWarrantyClaim(!warrantyClaim);
    }
    const onSave = () => {
        postWorkType().then(() => (
            onClear()
        ))
    }

    return (
        <Box className="settings_type">
            <details>
                <summary><Title>Add Workshop Expense Charge Type</Title></summary>
            <Columns isMultiline>
                {nameInput}
                <Column>
                    <Field>
                        <label className="label">Free of Charge Work</label>
                        <Checkbox
                            name={"free_of_charge"}
                            checked={freeOfCharge}
                            onChange={onFreeOfChargeCheck}
                        />
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Approval Needed</label>
                        <Checkbox
                            name={"approval_needed"}
                            checked={approval}
                            onChange={onApprovalCheck}
                        />
                    </Field>
                </Column>
                <Column>
                    <Field>
                        <label className="label">Should Claim for Warranty</label>
                        <Checkbox
                            name={"warranty_claim"}
                            checked={warrantyClaim}
                            onChange={onWarrantyClaimCheck}
                        />
                    </Field>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={onSave}
                        isFullWidth
                    >
                        Add
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );
}